import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './store';

interface WebMenuState {
    isMinimised: boolean;
    activeMenuItem: string | null;
    query?: string;
    prevScrollY: number;
}

const initialState: WebMenuState = {
    isMinimised: false,
    activeMenuItem: null,
    query: '',
    prevScrollY: 0
};

const scrollThreshold = 80;

export const webMenuSlice = createSlice({
    name: 'webMenu',
    initialState,
    reducers: {
        show: (state) => {
            state.isMinimised = false;
        },
        hide: (state) => {
            state.isMinimised = true;
        },
        setActiveMenuItem: (state, action: PayloadAction<string>) => {
            state.activeMenuItem = action.payload;
        },
        handleScroll: (state, action) => {
            const { contentOffset } = action.payload.nativeEvent;
            const { y } = contentOffset;
            if (!state.isMinimised && y > 80) {
                state.isMinimised = true;
            } else if (state.isMinimised && y < 80) {
                state.isMinimised = false;
            }
        },
        setQuery: (state, action: PayloadAction<string>) => {
            state.query = action.payload;
        }
    }
});

export const { show, hide, handleScroll, setActiveMenuItem, setQuery } = webMenuSlice.actions;

export const isMinimised = (state: RootState) => state.webMenu.isMinimised;
export const query = (state: RootState) => state.webMenu.query;

export default webMenuSlice.reducer;
